import { NgModule } from '@angular/core';

import { ThfComponentsModule } from './components/components.module';

@NgModule({
  imports: [
    ThfComponentsModule
  ],
  exports: [
    ThfComponentsModule
  ]
})
export class ThfTemplatesModule { }
